<template>
    <div class="classroomHeader">
        <el-tooltip content="返回" placement="bottom" effect="light">
            <el-button icon="el-icon-arrow-left" @click="goBack" circle></el-button>
        </el-tooltip>
        <img class="logo" :src="logo" alt="">
        <div class="funRegionBox">
            <el-button-group v-if="lessonType == 'scratch' || lessonType == 'python'">
                <el-button type="primary" @click="changeTab('board')" round>课件</el-button>
                <el-button type="primary" @click="changeTab('editor')" round>编程</el-button>
            </el-button-group>
        </div>
        <div class="rightBox">
            <div class="timeAnddownClass">
                <span>{{ `已上课 ${hours}：${minute}：${second}` }}</span>
            </div>
            <svg-icon icon-class="settings" @click="setSettingVisible(true);"/>
        </div>
        <SettingDialog></SettingDialog>
    </div>
</template>
<script>
import SettingDialog from './settingsDialog';
import { mapMutations, mapGetters } from 'vuex';
export default {
    components: {
        SettingDialog
    },
    props: [
        'lessonTime', 
        'handlerStuTab', 
        'lessonType',
        'cameraStream'
    ],
    computed: {
        ...mapGetters(["classData"]),
        logo(){
            return this.$store.getters.brandLogo
        },
        lessonTypes() {
            if(this.lessonType == 'scratch' || this.lessonType == 'python') {
                return true;
            }
        }
    },
    data() {
        return {
            interval: "",
            hours: 0,
            minute: 0,
            second: 0,
            origin: `${location.origin}/personhome`
        }
    },
    watch: {
        lessonTime() {
            if(this.lessonTime) {
                let time = Number(new Date()) - Number(this.lessonTime);
                this.hours = parseInt(time / 1000 / 60 / 60);
                this.minute = parseInt(time / 1000 / 60) % 60;
                this.second = parseInt(time / 1000) % 60;
                this.interval = setInterval(() => {
                    if(this.second + 1 == 60) {
                        this.minute++;
                    }
                    if(this.minute + 1 >= 60) {
                        this.minute = (this.minute + 1) % 60;
                        this.hours++;
                    }
                    this.second = (this.second + 1) % 60;
                }, 1000)
            } else {
                clearInterval(this.interval);
            }
        },
        stopTime() {

        },
    },
    methods: {
        ...mapMutations(["setClassData", "setSettingVisible"]),
        goBack() {
            window.location.replace(location.origin + '/personhome') 
        },
        changeTab(type) {
            if(type == 'editor') {
                this.setClassData({
                    ...this.classData,
                    currentTab: `${type}_${this.lessonType}`
                })
            } else {
                this.setClassData({
                    ...this.classData,
                    currentTab: type
                })
            }
            
            console.log(this.classData)
        },
    },
}
</script>
<style lang="scss">
.classroomHeader {
    position: relative;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 50px;
    padding: 0 10px;
    background-color: var(--theme-color);
    .el-button-group .el-button--primary {
        font-weight: 600;
        background-color: #fff;
        border-color: var(--theme-color);
        color: var(--theme-color);
        border-left-color: var(--theme-color) !important;
        border-right-color: var(--theme-color) !important;
    }
    .logo {
        position: absolute;
        top: 5px;
        left: 85px;
        max-width: 300px;
        // max-height: 48px;
        height: 40px;
        // line-height: 50px;
    }
    .funRegionBox {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        flex-flow: row nowrap;
        justify-content: center;
    }
    .timeAnddownClass {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        max-width: 235px;
        height: 36px;
        background-color: #fff;
        border-radius: 20px;
        overflow: hidden;
        user-select: none;
    }
    .timeAnddownClass span {
        white-space: nowrap;
    }
    .timeAnddownClass span:nth-child(1) {
        display: inline-block;
        padding: 0 15px;
    }
    .rightBox {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
    }
    .rightBox .svg-icon {
        width: 2rem;
        height: 2rem;
        margin-left: 10px;
        cursor: pointer;
    }
}
</style>


// WEBPACK FOOTER //
// src/views/classroom1/components/classroomHeader.vue